class ProjectDetailsController {
    constructor($route, $routeParams, UserDetailsApi, ProjectTestingServiceApi, UtpSimTestSuitesServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.routeParams = this.getRouteParams();
            this.testSuites = [];
            this.ProjectTestingServiceApi.getTeamProject(this.routeParams.projectId)
                .then((response) => {
                this.project = response.data;
            });
            this.UtpSimTestSuitesServiceApi.simulatorTestSuites(this.routeParams.simulatorId)
                .then((response) => {
                response.data.TestSuites.forEach(i => this.testSuites.push(i));
            });
        };
        this.getRouteParams = () => {
            let params;
            try {
                params = {
                    testerId: parseInt(this.resolve.testerId, 10),
                    simulatorId: parseInt(this.resolve.simId, 10),
                    projectId: parseInt(this.resolve.projectId, 10)
                };
            }
            catch (ex) {
                // this.toastr.warning(ex);
            }
            return params;
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.route = $route;
        this.routeParamService = $routeParams;
        this.UserDetailsApi = UserDetailsApi;
        this.ProjectTestingServiceApi = ProjectTestingServiceApi;
        this.UtpSimTestSuitesServiceApi = UtpSimTestSuitesServiceApi;
        this.project = null;
    }
    getPercentage(value, total) {
        if (value === total)
            return 100;
        if (value === 0)
            return 0;
        if (value > total)
            throw new Error('Value cannot be larger than total');
        if (value < 0)
            throw new Error('Value cannot be less than 0');
        return Math.round((value / total) * 100);
    }
}
angular.module('app').component('projectDetails', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    controllerAs: 'vm',
    controller: ProjectDetailsController,
    templateUrl: 'scripts/app/partials/TestExecution/ProjectTesting/project-details.tpl.html'
});
